import React from 'react';
import { compose } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

const styles = {};

const enhance = compose();

const tableHead = enhance(({ roles }) => {
  return (
    <TableHead>
      <TableRow>
        {(roles.isSecretariat || roles.isDeveloper) && <TableCell />}
        {(roles.isSecretariat || roles.isDeveloper) && <TableCell />}
        <TableCell>確認状況</TableCell>
        <TableCell>NG理由</TableCell>
        <TableCell>運営会社名</TableCell>
        <TableCell>住所</TableCell>
        <TableCell>メールアドレス</TableCell>
        <TableCell>電話番号</TableCell>
        <TableCell>FAX</TableCell>
        <TableCell>グループ種別</TableCell>
      </TableRow>
    </TableHead>
  );
});

export default withStyles(styles)(tableHead);
